var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioWaveIcon = function SvgAudioWaveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 .934a7.066 7.066 0 1 1 0 14.132A7.066 7.066 0 0 1 8 .934m0 .8a6.267 6.267 0 1 0 0 12.533A6.267 6.267 0 0 0 8 1.733m.4 10h-.8V4.266h.8zm-2-1.334h-.8V5.6h.8zm4 0h-.8V5.6h.8zm-6-1.334h-.8V6.934h.8zm8 0h-.8V6.934h.8z"
  })));
};
export default SvgAudioWaveIcon;